import { defineAsyncComponent } from 'vue';

export const exclusiveGift = () =>
  defineAsyncComponent(() => import('@/fairplayer/primary/marketplace/printable-exclusive-gift/PrintableExclusiveGift.vue'));
